export default __webpack_public_path__ + "/dist/images/facebook.98fe5d7b70a2d9f9ffd1080cc8cb17f3.svg";